import { Component, EventEmitter, inject, Input, Output } from '@angular/core';
import { ValidationErrorInterface } from '@zaoblako/shared/common/interfaces/validation-error.interface';
import type { SerdeDtoClass } from '@zaoblako/shared/modules/serde/classes/serde-dto.class';
import type { SerdeContextDataInterface } from '@zaoblako/shared/modules/serde/interfaces/serde-context-data.interface';
import { ErrorService } from '@zaoblako/web/core/services/error.service';
import { ValidationService } from '@zaoblako/web/core/services/validation/validation.service';
import { flatten } from 'flat';

@Component({
  selector: 'crm-base-form',
  template: ''
})
export abstract class BaseFormComponent<T> {
  @Input() public saveButtonLabel = 'Сохранить';
  @Input() public canDelete = false;
  @Input() public canWrite = true;

  @Output() public save = new EventEmitter<T>();
  @Output() public delete = new EventEmitter<T>();

  @Input() public route: string;
  public errors: T extends Array<infer I> ? Array<ValidationErrorInterface<I>> : ValidationErrorInterface<T>;

  @Input() public isModal = false;

  public abstract dto: SerdeDtoClass<T>;

  public readonly validationService = inject(ValidationService);
  private readonly _errorService = inject(ErrorService);

  public onSave<D extends SerdeContextDataInterface = SerdeContextDataInterface>(entity: T, contextData?: D) {
    const [result, errors] = this.validationService.parseAndValidate<T, D>(
      entity,
      this.dto as SerdeDtoClass<T>,
      contextData
    );
    if (errors) {
      this.errors = errors.validationErrors;
      console.log(entity);
      console.error(this.errors);
      this._errorService.addCustomError(
        'Ошибка валидации',
        Object.keys(this.errors)
          .map((key) => `[${key}]: ${this.errors[key]};`)
          .join('\n')
      );
    } else {
      this.errors = null;
      this.save.emit(result);
    }
  }

  public checkValidate<D extends SerdeContextDataInterface = SerdeContextDataInterface>(entity: T, contextData?: D) {
    const [result, errors] = this.validationService.parseAndValidate<T, D>(
      entity,
      this.dto as SerdeDtoClass<T>,
      contextData
    );
    if (errors) {
      const metadata = this.dto.getMetadata(contextData);
      this.errors = errors.validationErrors;

      // [from Alexander Sychev]: Эпический "костыль", чтобы избежать "[object Object]" в ошибках фронтенда
      for (const [key, value] of Object.entries(this.errors)) {
        if (typeof value === 'object' && !metadata[key]?.nested) {
          const flatValue: Record<string, string> = flatten(value);
          this.errors[key] = Object
            .values(flatValue)
            .join('\n');
        }
      }

      console.log(entity);
      console.error(this.errors);
    } else {
      this.errors = null;
    }
    return {
      errors,
      valid: !!result
    };
  }
}
